<template>
  <v-dialog v-model="show" persistent max-width="650">
    <v-card>
      <v-card-title>Pricing Changes</v-card-title>
      <v-card-text class="body-1">
        <p>There have been pricing changes since this job was made inactive, these changes have been shown below.</p>
        <p class="mb-0">
          If you are not happy with the new pricing, you may remove the translations after you have accepted these updates.
        </p>
      </v-card-text>
      <div class="activity-list">
        <PricingChangeActivityLine v-if="!isMobile" title />
        <v-divider class="mb-3" />
        <div v-for="(activity, index) in activities" :key="index">
          <PricingChangeActivityLine :activity="activity" :mobile="isMobile" />
          <v-divider class="my-3" />
        </div>
      </div>
      <v-card-actions class="d-flex justify-end">
        <v-btn text color="tertiary" @click="close()">
          Cancel
        </v-btn>
        <v-btn text color="tertiary" @click="accept()">
          Accept
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import PricingChangeActivityLine from './PricingChangeActivityLine.vue'

export default {
  components: { PricingChangeActivityLine },
  data() {
    return {
      show: false,
      activities: []
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly
    }
  },
  methods: {
    open(activities) {
      this.activities = activities
      this.show = true
    },
    close() {
      this.activities = []
      this.show = false
    },
    accept() {
      this.$emit('accept')
      this.close()
    }
  }
}
</script>
<style scoped>
.activity-list {
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 10px;
}
</style>
